'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FILTER = 'filter';

var filterHistory = function filterHistory(localStorageService) {
    _classCallCheck(this, filterHistory);

    return {
        saveFilter: function saveFilter(filter, key) {
            var filterObj = localStorageService.get(FILTER) || {};
            filterObj[key] = filter;
            localStorageService.set(FILTER, filterObj);
        },
        readFilter: function readFilter(key) {
            var filter = localStorageService.get(FILTER) || {};
            return filter[key];
        },
        removeFilter: function removeFilter(key) {
            var filter = localStorageService.get(FILTER);
            delete filter[key];
            localStorageService.set(FILTER, filter);
        }
    };
};

exports.default = filterHistory;


filterHistory.inject = ['localStorageService'];


/** WEBPACK FOOTER **
 ** ./src/app/services/filterHistory.js
 **/